import { msalInstance } from "./AuthProvider";
import events from "events";
import { store } from "../store/store";
import { setTokenCreated } from "../actions/tokenActions";
import { graphTokenRequest, jwtTokenRequest } from "../authConfig";

// Create an eventEmitter object
export const eventEmitter = new events.EventEmitter();
export const allTabs = ["/", "/nominations","/nomDashboard","/thoughtStarters","/faqDetails","/thankYou","/admin"];
export let accesstoken: any;
export let jwtaccesstoken: any;



let userId: any;
export const setUserId = (id: any) => {
  userId = id;
};
export const getUserId = () => userId;

let usergraphId: any;
export const setUserGraphId = (id: any) => {
  usergraphId = id;
};
export const getUserGraphId = () => usergraphId;

let reportURL: any;
export const setReportURL = (id: any) => {
  reportURL = id;
};
export const getReportURL = () => reportURL;

let instrumentationKey: any;
export const setInstrumentationKey = (id: any) => {
  instrumentationKey = id;
};
export const getInstrumentationKey = () => instrumentationKey;

let nominatorId: any;
export const setNominatorId = (id: any) => {
  nominatorId = id;
};
export const getNominatorId = () => nominatorId;

let nominatorMail: any;
export const setNominatorMail = (mail: any) => {
  nominatorMail = mail;
};
export const getNominatorMail = () => nominatorMail;


export const getNominatorName = () => nominatorName;

let nominatorName: string;
export const setNominatorName = (name: string) => {
  nominatorName = name;
};

let emailNotificationEabled: string;
export const setemailNotificationEabled = (isEnabled: string) => {
  emailNotificationEabled = isEnabled;
};

export const getemailNotificationEabled = () => emailNotificationEabled;

export const getNominatorHashedMail = () => nominatorMail;


interface Category {
  id: number;
  name: string;
  parentId: number;
}

let draftMode: any;
let submitMode: any;
const categoryMap = new Map();
const categoryParentMap = new Map();


export const setDraftSubmitMode = (category: Category[]) => {
  category.map(c => {
    if (c.name.toLowerCase() === "draft") {
      draftMode = c.id;
    } else if (c.name.toLowerCase() === "submitted") {
      submitMode = c.id;
    } else {
      categoryMap.set(c.name.toLowerCase(), c.id);
      categoryParentMap.set(c.name.toLowerCase(), c.parentId);
    }
  });
  eventEmitter.emit("createdCategories", categoryMap);

}



export const getDraftMode = () => draftMode;
export const getSubmitMode = () => submitMode;
export const getCategoryMap = () => categoryMap;
export const getCategoryParentMap = () => categoryParentMap;


let userInfo: any;
export const setUserInfo = (info: any) => {
  userInfo = info;
};
export const getUserInfo = () => userInfo;

export const getToken = () => {
  return new Promise(async (resolve: any, reject: any) => {
    try {
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        const response = await msalInstance.acquireTokenSilent({
          ...graphTokenRequest,
          account: accounts[0]
        });
        accesstoken = response.accessToken;
        resolve(accesstoken);
      } else {
        reject("No accounts found");
      }
    } catch (error) {
      console.error("Error acquiring token:", error);
      reject(error);
    }
  })
};

export const getJWTToken = () => {
  return new Promise(async (resolve: any, reject: any) => {
    try {
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        const response = await msalInstance.acquireTokenSilent({
          ...jwtTokenRequest,
          account: accounts[0]
        });
        jwtaccesstoken = response.accessToken;
        resolve(jwtaccesstoken);
      } else {
        reject("No accounts found");
      }
    } catch (error) {
      console.error("Error acquiring JWT token:", error);
      reject(error);
    }
   })
};




export const getMiddleName = (firstMiddleName: string) => {
  let names = firstMiddleName.trim().split(" ");
  let middleName = names.length > 1 ? names.splice(1, names.length).join(" ").trim() : ""
  return middleName;
}

export const getFirstName = (firstMiddleName: string) => {
  let names = firstMiddleName.trim().split(" ");
  return names[0].trim();
}

let autoSaveVal:any;
export const setAutoSaveVal = (val:any)=>{
  autoSaveVal = val
}

export const getAutoSaveVal = ()=>autoSaveVal

let IsAnonymous:any;
export const setIsAnonymous = (val:any)=>{
  IsAnonymous = val
}

export const getIsAnonymous = ()=>IsAnonymous

let adminDetails:any;
export const setadminDetails = (val:any)=>{
  adminDetails = val
}

export const getadminDetails = ()=>adminDetails

let isAdminExists:boolean;
export const setisAdminExists=(value:boolean)=>{
  isAdminExists=value;
}
export const getIsAdminExists=()=>isAdminExists
let AccountIdentifierdetails:any;
export const setAccountIdentifier = (val:any)=>{
  AccountIdentifierdetails = val
}
export const getAccountIdentifier = ()=>AccountIdentifierdetails

let isAdminSelected:boolean
export const setisAdminSelected=(value:boolean)=>{
  isAdminSelected=value;
}
export const getisAdminSelected=()=>isAdminSelected
let isEnabled:any;
export const setIsEnabled = (val:boolean)=>{
  isEnabled = val
}
export const getIsEnabled = ()=>isEnabled

let isLangHdr:any;
export const setIsLangHdr = (val:boolean)=>{
  isLangHdr = val
}
export const getIsLangHdr = ()=>isLangHdr

let draftNominationDetails:any;
export const setdraftNominationDetails = (val:any)=>{
  draftNominationDetails = val
}
export const getdraftNominationDetails = ()=>draftNominationDetails
